import * as React from 'react';
import QrScanner from 'react-qr-barcode-scanner';

export default function Main({ handleChange }) {
  return (
    <div id="wrapper" >
      <div id="content">
        <div>
          <div>
            <div id="contract" >
              <div id="outputPage">
                <div>
                  <div >
                    <p><strong>https://tjbageneral.ddns.net/ Privacy Policy</strong>
                    </p>
                    <p >Type of website: MES<br />Effective date: 20th day of April, 2026
                    </p>
                    <p >https://tjbageneral.ddns.net/ (the "Site") is owned and operated by Carlos Reyes. Carlos Reyes can be contacted at: <br /><br />carlos.ilamas@clearxaligners.com<br />________________________________________<br />Corredor Tijuana - Rosarito 2000 22002, El Realito, 22250 Tijuana, B.C.
                    </p>
                    <p ><strong><u>Purpose</u></strong><br />The purpose of this privacy policy (this "Privacy Policy") is to inform users of our Site of the following:
                    </p>
                    <ol start="1">
                      <li value="1"><span>The personal data we will collect;</span><br />
                      </li>
                      <li value="2"><span>Use of collected data;</span><br />
                      </li>
                      <li value="3"><span>Who has access to the data collected; and</span><br />
                      </li>
                      <li value="4"><span>The rights of Site users.</span><br />
                      </li>
                    </ol>
                    <p >This Privacy Policy applies in addition to the terms and conditions of our Site.
                    </p><div>
                      <p ><strong><u>Consent</u></strong><br />By using our Site users agree that they consent to:
                      </p>
                      <ol start="1">
                        <li value="1"><span>The conditions set out in this Privacy Policy; and</span><br />
                        </li>
                        <li value="2"><span>The collection, use, and retention of the data listed in this Privacy Policy.</span><br />
                        </li>
                      </ol></div>
                    <p ><strong><u>How We Use Personal Data</u></strong><br />Data collected on our Site will only be used for the purposes specified in this Privacy Policy or indicated on the relevant pages of our Site. We will not use your data beyond what we disclose in this Privacy Policy.
                    </p>
                    <p ><strong><u>Who We Share Personal Data With</u></strong><br /><u>Employees</u><br />We may disclose user data to any member of our organization who reasonably needs access to user data to achieve the purposes set out in this Privacy Policy.
                    </p><div>
                      <p ><u>Other Disclosures</u><br />We will not sell or share your data with other third parties, except in the following cases:
                      </p>
                      <ol start="1">
                        <li value="1"><span>If the law requires it;</span><br />
                        </li>
                        <li value="2"><span>If it is required for any legal proceeding;</span><br />
                        </li>
                        <li value="3"><span>To prove or protect our legal rights; and</span><br />
                        </li>
                        <li value="4"><span>To buyers or potential buyers of this company in the event that we seek to sell the company.</span><br />
                        </li>
                      </ol>
                      <p >If you follow hyperlinks from our Site to another Site, please note that we are not responsible for and have no control over their privacy policies and practices.
                      </p></div>
                    <p ><strong><u>How Long We Store Personal Data</u></strong><br />User data will be stored for 0 days.<br /><br />You will be notified if your data is kept for longer than this period.
                    </p>
                    <p ><strong><u>How We Protect Your Personal Data</u></strong><br />Encription<br /><br />While we take all reasonable precautions to ensure that user data is secure and that users are protected, there always remains the risk of harm. The Internet as a whole can be insecure at times and therefore we are unable to guarantee the security of user data beyond what is reasonably practical.
                    </p><div>
                      <p ><strong><u>Children</u></strong><br />The minimum age to use our website is 21 years of age. We do not knowingly collect or use personal data from children under 13 years of age. If we learn that we have collected personal data from a child under 13 years of age, the personal data will be deleted as soon as possible. If a child under 13 years of age has provided us with personal data their parent or guardian may contact our privacy officer.
                      </p></div>
                    <p ><strong><u>How to Access, Modify, Delete, or Challenge the Data Collected</u></strong><br />If you would like to know if we have collected your personal data, how we have used your personal data, if we have disclosed your personal data and to who we disclosed your personal data, or if you would like your data to be deleted or modified in any way, please contact our privacy officer here:<br /><br />Carlos Reyes<br />carlos.ilamas@clearxaligners.com<br />________________________________________<br />Corredor Tijuana - Rosarito 2000 22002, El Realito, 22250 Tijuana, B.C.
                    </p>
                    <p ><strong><u>Modifications</u></strong><br />This Privacy Policy may be amended from time to time in order to maintain compliance with the law and to reflect any changes to our data collection process. When we amend this Privacy Policy we will update the "Effective Date" at the top of this Privacy Policy. We recommend that our users periodically review our Privacy Policy to ensure that they are notified of any updates. If necessary, we may notify users by email of changes to this Privacy Policy.
                    </p>
                    <p ><strong><u>Contact Information</u></strong><br />If you have any questions, concerns or complaints, you can contact our privacy officer, Carlos Reyes, at:<br /><br />carlos.ilamas@clearxaligners.com<br />________________________________________<br />Corredor Tijuana - Rosarito 2000 22002, El Realito, 22250 Tijuana, B.C.
                    </p></div><div class="LDCopyright">
                    <p>©2002-2026 LawDepot.com®</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>





      </div>
    </div>
  );
};